import { AppPath } from '@ipensii/shared/domain-shared';

export enum EmployerPath {
  employer = 'employer',
  details = 'details',
  hrEmployee = 'hrEmployee',
  employee = 'employee',
  reportingDashboard = AppPath.reportingDashboard,
  fundAdmin = 'fundAdmin'
}

export enum EmployerPathParam {
  employeeId = 'employeeId',
}

export class EmployerRouterLinkBuilder {
  static employerDashboard(): Array<unknown> {
    return ['/', EmployerPath.employer];
  }

  static employeeList(): Array<unknown> {
    return [...EmployerRouterLinkBuilder.employerDashboard(), EmployerPath.employee];
  }

  static employeeDetails({ employeeId }: { employeeId: string }): Array<unknown> {
    return [...EmployerRouterLinkBuilder.employeeList(), employeeId];
  }
}
